<template><div><h1 id="liste-umsatze-nach-auftragsart-personenfilter" tabindex="-1"><a class="header-anchor" href="#liste-umsatze-nach-auftragsart-personenfilter"><span>Liste Umsätze nach Auftragsart, Personenfilter</span></a></h1>
<p>Liste Umsätze nach Auftragsart, Personenfilter — Zeigt Umsätze und Versandkosten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung dient der Auflistung der Umsätze einer bestimmten Auftragsart, zusätzlich eingrenzbar nach Adressfilter und einem bestimmten Zeitraum, abhängig vom Erfassungsdatum des Auftrags. Die gewünschten Detailinformationen können beeinflusst werden. Als Umsätze werden auch Porti und Versandspesen aufgelistet. Zeigt, abhängig von den gewählten Output-Parametern, verschiedene Zwischentotale an.</p>
<p>Pfad:</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Auftragsart:</dt>
<dd>Auszuwertende Auftragsarten, mit Komma trennen, mit ! ausschliessen, * = alle</dd>
<dt>FilterNummer.</dt>
<dd>Einschränkung der auszuwertenden Umsätze nach Adressfilter</dd>
<dt>Erfassungsdatum von:</dt>
<dd>Einschränkung nach Zeitraum</dd>
<dt>bis:</dt>
<dd>Einschränkung nach Zeitraum</dd>
<dt>mit Auftragspositionen:</dt>
<dd>Nein: Listet alle Aufträge einzeln auf, ohne Details zu zeigen. (Standard)<br>Ja: Listet alle Aufträge mit den Details, den einzelnen Auftragspositionen auf</dd>
<dt>nur Auftragstotale:</dt>
<dd>Nein: listet jeden Auftrag einzeln auf (mit oder ohne Details)<br>Ja: listet nur Auftragstotal pro Adresse auf (wenn mehrere Aufträge vorhanden sind)</dd>
<dt>Export in Textfile/Excel:</dt>
<dd>formatiert Output für T = Textdatei; E = tabulatorgetrennte Datei für Excel</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Quer)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet (je nach Wahl von der Parameter) die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AdrNr.</td>
<td>Personen-ID / Auftraggeber</td>
</tr>
<tr>
<td>Adressname</td>
<td>Name</td>
</tr>
<tr>
<td>PLZ</td>
<td>PLZ</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort</td>
</tr>
<tr>
<td>AA</td>
<td>Auftragsart</td>
</tr>
<tr>
<td>AufNr.</td>
<td>Auftragsnummer</td>
</tr>
<tr>
<td>BestellW.</td>
<td>Wert Bestellungen (was wurde im Auftrag erfasst)</td>
</tr>
<tr>
<td>LieferW.</td>
<td>Wert Lieferungen (was wurde effektiv ausgeliefert)</td>
</tr>
<tr>
<td>RetourW.</td>
<td>Wert Retouren (was wurde retourniert)</td>
</tr>
<tr>
<td>AuftragW.</td>
<td>Wert Auftragswert (was war effektiv der Umsatz: Wert Lieferungen - Retouren)</td>
</tr>
<tr>
<td>FaktNr.</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>ArtNr.</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Bez.</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Menge</td>
<td>Anzahl Artikel</td>
</tr>
<tr>
<td>GesamtPr</td>
<td>Wert Artikel</td>
</tr>
<tr>
<td>S</td>
<td>Status der Auftragsposition</td>
</tr>
</tbody>
</table>
<h2 id="liste-umsatze-nach-auftragsart-adressfilter-14-12-2001-11-09-04-svw-seite-0" tabindex="-1"><a class="header-anchor" href="#liste-umsatze-nach-auftragsart-adressfilter-14-12-2001-11-09-04-svw-seite-0"><span>Liste Umsätze nach Auftragsart, Adressfilter                    14.12.2001 11:09:04 svw  Seite     0</span></a></h2>
<pre><code>             Liste Umsätze nach Auftragsart, Adressfilter
        Auftragsart..............: dm
        FilterNummer.............: 0
        Erfassungsdatum von......: 18.08.2000 bis: 31.08.2000
        mit Auftragspositionen...: ja
        nur Auftragstotale.......: nein
        export in Textdatei/Excel: T

        Testseitenanzahl:
</code></pre>
<h2 id="adrnr-adressname-plz-ort-aa-aufnr-bestellw-lieferw-retourw-auftragw-faktnr-artnr-bez-menge-gesamtpr-s" tabindex="-1"><a class="header-anchor" href="#adrnr-adressname-plz-ort-aa-aufnr-bestellw-lieferw-retourw-auftragw-faktnr-artnr-bez-menge-gesamtpr-s"><span>AdrNr. Adressname    PLZ    Ort        AA   AufNr.   BestellW.    LieferW.    RetourW.   AuftragW. FaktNr. ArtNr.  Bez.                 Menge   GesamtPr S</span></a></h2>
<p>181361 Müller Alfred 3453   Heimisbach dm  1407151       82.50       82.50        0.00       82.50
2443826 K920    Kindergeschirr &quot;Spie     1      29.00 I
2443826 K806    4 Trinkgläser, Set 1     1      24.00 I
2443826 K968    4 Trinkgläser, Set 2     1      24.00 I
2443826 Porto   Versandkosten            1       5.50 I
317415 Wüthrich Walt 8142   Uitikon Wa dm  1407351       23.50       23.50        0.00       23.50
2443913 02830   Licht in der Natur,      1      18.00 I
2443913 Porto   Versandkosten            1       5.50 I
...</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel werden in dieser Statistik nicht mitgezählt.</p>
</div>
</div></template>


